module.exports = __webpack_public_path__ + "static/MC_steps_nuevos_VIRTUAL_4_B-1aeb6fe5883781fc81bdb72ac40daaa0.gif";